import ServiceContainer from 'config/ServiceContainer';
import CraService from '../../service/CraService';
import { ServiceNames } from 'constant/ServiceNames';
import React, { Component, ComponentState } from 'react';
import { ConfirmPopup } from 'primereact/confirmpopup';
import CustomTable, { CustomColumnProps } from '../../components/custom/CustomTable';
import ListDraggableItem from 'components/custom/ListDraggableItem';
import EmptyComponent from 'components/custom/empty-components/EmptyComponent';
import { setSelectedItems } from 'redux/actions/ComponentActions';
import LanguageUtil from '../../util/LanguageUtil';
import { CraVariableSchema } from '../../domain/cra/CraDomains';
import { RootState, dispatch } from '../../redux/store';
import { connect, ConnectedProps } from 'react-redux';
import RoleHelper from 'RoleHelper';
import { customConfirm } from '../../components/custom/CustomPopupConfirm';
import ComponentUtil from '../../util/ComponentUtil';
import CustomTableContentWrapper from '../../components/custom/CustomTableContentWrapper';
import Icon from '../../icons/Icon';
import { query } from '@trlogic/client-js';
import ComponentName from '../../constant/ComponentName';
import Order = query.Order;
import FormicaToggleSwitch from 'components/custom/FormicaToggleSwitch';

class CraListViewerComponent extends Component<Props, State> {
  public state: State = new State();
  private craService: CraService = ServiceContainer.getInstance().get(ServiceNames.CRA);

  public render() {
    const {
      variables,
      component: { selectedComponentIds },
    } = this.props;
    return variables && variables.length > 0 ? (
      <div className={'overflow-y-scroll max-h-[calc(100dvh-430px)] scrollable-editor-container 2xl:max-h-[calc(100dvh-460px)] flex w-full  rounded-lg'}>
        <ConfirmPopup />
        <CustomTable
          value={variables}
          selectionMode='checkbox'
          selection={selectedComponentIds}
          onSelectionChange={this.onSelectionChange}
          componentName={ComponentName.POLICY}
          openNewTab={true}
          columns={this.getColumns()}
        />
        <ListDraggableItem itemType={ComponentName.POLICY} currentModal={this.props.currentModal} />
      </div>
    ) : (
      <EmptyComponent type={ComponentName.POLICY} createDisabled={true} />
    );
  }

  public componentDidMount() {
    const { variables } = this.props;
    this.setState({ variables, loading: false });
  }

  private onSelectionChange = (e: any) => {
    dispatch(setSelectedItems(e.value));
  };

  private openEditor = (name: string) => {
    const { openEvent } = this.props;
    openEvent(name);
  };

  private getColumns = (): CustomColumnProps[] => {
    const { policy } = this.props;
    const columns: CustomColumnProps[] = [
      {
        field: 'name',
        header: LanguageUtil.get({ id: 'pages.cra.table.name', defaultMessage: 'Name' }),
        className: 'min-w-[18%] ',
        copyable: true,
        onCopy: (e: CraVariableSchema) => e.name,
        body: (record: CraVariableSchema) => {
          return (
            <div className={'text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={record.name} clipSize={30} showEllipsis={true} />
            </div>
          );
        },
      },
      {
        field: 'type',
        header: LanguageUtil.get({ id: 'pages.cra.table.datatype', defaultMessage: 'Data Type' }),
        className: 'min-w-[20%]',
        body: (record: CraVariableSchema) => <span>{record.type}</span>,
      },
      {
        field: 'weight',
        header: LanguageUtil.get({ id: 'pages.cra.table.weight', defaultMessage: 'Weight' }),
        className: 'min-w-[12%]',
        body: (record: CraVariableSchema) => <span>{record.weight}</span>,
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'pages.cra.table.description', defaultMessage: 'Description' }),
        className: 'min-w-[25%]',
        body: (record: CraVariableSchema) => <CustomTableContentWrapper text={record.description || ''} />,
      },
      {
        field: 'isEnabled',
        header: LanguageUtil.get({ id: 'pages.cra.table.isEnabled', defaultMessage: 'Enabled' }),
        className: 'min-w-[12%]',
        body: (record: CraVariableSchema) => (
          <FormicaToggleSwitch
            value={record.isEnabled ?? false}
            onChange={async (e) => {
              await this.craService.variableEnable(record.name, policy.assessor);
            }}
          />
        ),
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.cra.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[90px] 2xl:max-w-[100px]',
        sortable: false,
        body: (record: CraVariableSchema) => {
          const isLocked = ComponentUtil.isLocked(ComponentName.POLICY, record.name);
          if (isLocked) {
            return null;
          }
          return (
            <div className={'flex w-full justify-start items-center gap-x-4'}>
              <button onClick={() => this.openEditor(record.name)}>
                <Icon icon={'preferences'} size={30} color={'primary'} className='hover:text-primary text-f-black-3 cursor-pointer' />
              </button>
              <button
                onClick={(e) => {
                  customConfirm({
                    target: e.currentTarget,
                    accept: async () => await this.craService.delete(record.name, policy.assessor),
                    message: LanguageUtil.get({ id: 'messages.confirm.remove1', defaultMessage: 'Are you sure you want to remove?' }),
                  });
                }}
              >
                <Icon icon={'delete'} size={25} color={'primary'} className='hover:text-primary text-f-black-3 cursor-pointer' />
              </button>
            </div>
          );
        },
      },
    ];

    return columns.filter((column) => {
      if (column.field === 'action') {
        return RoleHelper.canEdit('Cra');
      }
      return true;
    });
  };
}

class State {
  variables: CraVariableSchema[] = [];
  loading: boolean = true;
}

interface Props extends ReduxProps {
  variables: CraVariableSchema[];
  openEvent: (id: string) => void;
  views: any;
  currentModal: any;
}

const mapStateToProps = (state: RootState) => ({
  component: state.component as ComponentState,
  policy: state.policy.policy,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(CraListViewerComponent);
